import useSWR, { SWRConfiguration } from 'swr';
import { customSWRResponse } from '../../model/types';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useRenderedCompanySignature(
    isShowSignature: boolean,
    config: SWRConfiguration = {}
): customSWRResponse<string> {
    const keys = useSWRCacheKeys(isShowSignature ? `/settings/rendered-signature` : null);

    return useSWR<string>(keys, { ...config });
}
